var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangularWarning = function SvgTriangularWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E5F1FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#fff",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 25v4m0 4h.01m-1.395-13.108L18.39 34.099c-.456.788-.684 1.182-.65 1.505a1 1 0 0 0 .406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 0 0 .407-.705c.034-.323-.194-.717-.65-1.505l-8.226-14.207c-.454-.785-.681-1.178-.978-1.31a1 1 0 0 0-.813 0c-.296.132-.523.525-.978 1.31Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgTriangularWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSI0IiB5PSI0IiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIyNCIgZmlsbD0iI0U1RjFGQiIvPjxyZWN0IHg9IjQiIHk9IjQiIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgcng9IjI0IiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iOCIvPjxwYXRoIGQ9Ik0yOCAyNXY0bTAgNGguMDFtLTEuMzk1LTEzLjEwOEwxOC4zOSAzNC4wOTljLS40NTYuNzg4LS42ODQgMS4xODItLjY1IDEuNTA1YTEgMSAwIDAgMCAuNDA2LjcwNWMuMjYzLjE5MS43MTguMTkxIDEuNjI5LjE5MWgxNi40NWMuOTEgMCAxLjM2NSAwIDEuNjI4LS4xOTFhMSAxIDAgMCAwIC40MDctLjcwNWMuMDM0LS4zMjMtLjE5NC0uNzE3LS42NS0xLjUwNWwtOC4yMjYtMTQuMjA3Yy0uNDU0LS43ODUtLjY4MS0xLjE3OC0uOTc4LTEuMzFhMSAxIDAgMCAwLS44MTMgMGMtLjI5Ni4xMzItLjUyMy41MjUtLjk3OCAxLjMxWiIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPgo=";